function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M256,369.778l114.99,114.99c68.832-34.668,119.884-99.473,135.794-177.095L398.222,199.111 c-0.288,0-156.875,118.662-156.875,118.662L256,369.778z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5F1F4"
    },
    points: "199.111,142.222 113.778,199.111 255.857,199.111 255.857,142.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B5F1F4"
    },
    points: "312.889,142.222 255.857,142.222 255.857,199.111 398.222,199.111  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7BD4EF"
    },
    points: "398.222,199.111 255.857,199.111 255.857,369.605 256,369.778 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#84DBFF"
    },
    points: "113.778,199.111 255.857,369.605 255.857,199.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#84DBFF"
    },
    points: "312.889,199.111 256,142.222 199.111,199.111  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7BD4EF"
    },
    points: "256,142.222 255.857,142.365 255.857,199.111 312.889,199.111 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#31BAFD"
    },
    points: "199.111,199.111 256,369.778 312.889,199.111 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B9ED8"
    },
    points: "312.889,199.111 255.857,199.111 255.857,369.349 256,369.778 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#31BAFD"
    },
    points: "199.111,142.222 199.111,199.111 113.778,199.111 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B9ED8"
    },
    points: "312.889,142.222 312.889,199.111 398.222,199.111 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimond);
export default __webpack_public_path__ + "static/media/dimond.222f9cc294d07261d98eed561ab46deb.svg";
export { ForwardRef as ReactComponent };